module.exports = __webpack_public_path__ + "img/hidden.664e3f97.jpg";